module.exports = __webpack_public_path__ + "static/media/info.4eb24737.svg";